import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  background-color: "#19345E"
`;

export default GlobalStyle;
